module.exports = __webpack_public_path__ + "static/media/close-text-white.477a7e13.svg";